import React from 'react';
import { Link } from 'react-router-dom';

export const STATUS_STYLES = {
  Matched: 'bg-emerald-100 text-emerald-800',
  Mismatch: 'bg-red-100 text-red-700',
  'Not in Portal': 'bg-amber-100 text-amber-800',
  'Not in BenPos': 'bg-orange-100 text-orange-800',
  Match: 'bg-emerald-50 text-emerald-700',
  'N/A': 'bg-gray-100 text-gray-500',
};

export const Pill = ({ value, testId }) => (
  <span className={`inline-block px-2 py-0.5 rounded-full text-[11px] font-medium ${STATUS_STYLES[value] || 'bg-gray-100 text-gray-600'}`} data-testid={testId}>{value}</span>
);

export const fmtUnits = (n) => Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 4 });

const diffCell = (r) => <span className={Math.abs(r.difference) > 0.0001 ? 'text-red-600 font-semibold' : 'text-gray-500'}>{fmtUnits(r.difference)}</span>;

const accountCell = (r) => (r.account_ids?.length
  ? <Link to={`/investors/accounts/${r.account_ids[0]}`} className="text-blue-700 hover:underline">{r.account_name || '—'}</Link>
  : <span className="text-gray-400">—</span>);

const BASE_COLUMNS = [
  { key: 'pan', label: 'PAN' },
  { key: 'account_name', label: 'Account (Portal)', render: accountCell },
  { key: 'benpos_name', label: 'Name (BenPos)' },
  { key: 'folio_no', label: 'Folio No' },
  { key: 'isin', label: 'ISIN' },
  { key: 'class_name', label: 'Class' },
  { key: 'portal_units', label: 'Units per Portal', align: 'right', render: (r) => fmtUnits(r.portal_units), exportValue: (r) => r.portal_units },
  { key: 'benpos_units', label: 'Units per BenPos', align: 'right', render: (r) => fmtUnits(r.benpos_units), exportValue: (r) => r.benpos_units },
  { key: 'difference', label: 'Difference', align: 'right', render: diffCell, exportValue: (r) => r.difference },
  { key: 'status', label: 'Status', render: (r) => <Pill value={r.status} /> },
  { key: 'portal_bank_account', label: 'Bank A/c (Portal)' },
  { key: 'benpos_bank_account', label: 'Bank A/c (BenPos)' },
  { key: 'bank_status', label: 'Bank A/c Check', render: (r) => <Pill value={r.bank_status} /> },
  { key: 'portal_ifsc', label: 'IFSC (Portal)' },
  { key: 'benpos_ifsc', label: 'IFSC (BenPos)' },
  { key: 'ifsc_status', label: 'IFSC Check', render: (r) => <Pill value={r.ifsc_status} /> },
  { key: 'notes', label: 'Notes' },
];

export const RECON_COLUMNS = BASE_COLUMNS.map((col) => ({ ...col, section: 'BenPos Reconciliation' }));
